<script lang="ts" setup>
import { useRecordingUtils } from 'core'
import { z } from 'zod'

definePageMeta({
  path: '/listen/:id',
  layout: false
})

const route = useRoute('listen')
const audioId = route.params.id

const result = await useRecordingData(audioId)
const data = result.data.value

const isCustomOrigin = isCustomDomain(data?.user.domain)
const logo = data?.settings.logoUrl

if (!data) {
  useServerSeoMeta({
    title: 'Page not found'
  })
}

else {
  const { audio, settings, user } = data
  const utils = useRecordingUtils({ ...audio, domain: user.domain })

  const title = `Recording by ${settings.name || 'Someone'}`
  const description = utils.getTitle({ maxLength: 200 })
  const ogImage = audio.imageUrl

  useServerSeoMeta({
    title,
    description,
    titleTemplate: isCustomOrigin ? '%s' : undefined,

    ogTitle: title,
    ogDescription: description,
    ogAudioUrl: audio.audioUrl,
    ogImage,
    ogImageWidth: '350',
    ogUrl: utils.getLink(),
    ogType: 'website',

    twitterTitle: title,
    twitterDescription: description,
    twitterImage: ogImage,
    twitterCard: 'summary_large_image'

    // TODO: add twitter card when embed player is ready
  })

  // Apply Custom logo
  const logoUrl = z.string().url().safeParse(logo)

  if (logoUrl.success)
    useFavicon(logoUrl.data)
}

trackAudioPageListen(audioId)
</script>

<template>
  <PageListen :data :logo />
</template>
